import React from 'react';
import { ProjectImageSlot } from './ProjectImageSlot';
import { StatusBadge } from './StatusBadge';
import { ReviewNote } from '../ui/ReviewNote';
import type { LatestProject } from '../../types/latestProjects';
import { latestCategoryLabel, latestProjectDates, latestStatusLabel, publicValues } from '../../utils/latestProjects';
export function LatestProjectDetail({
  project
}: {
  project: LatestProject;
}) {
  const details: [string, string][] = [['Location', project.location], ...(project.clientApproved && project.client ? [['Client', project.client] as [string, string]] : []), ...(project.developmentManager ? [['Development manager', project.developmentManager] as [string, string]] : []), ...(project.contractArrangement ? [['Contract arrangement', project.contractArrangement] as [string, string]] : []), ['Status', latestStatusLabel(project.status)], ...latestProjectDates(project), ...publicValues(project).map(v => [v.label, v.amount] as [string, string])];
  return <article aria-labelledby="latest-detail-title" data-id="element-252" data-mp="22pqh58gchj4p">
      <ProjectImageSlot src={project.imageUrl} alt={project.imageAlt} data-id="element-253" data-mp="1xq5jd1cwvgtk" />

      <div className="px-5 py-7 sm:px-8" data-id="element-254" data-mp="1xnsvk7kh2c8l">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-2" data-id="element-255" data-mp="2cf1q8v38ensl">
          <StatusBadge status={project.status} data-id="element-256" data-mp="27o1tbpu445q3" />
          <span className="font-display text-[13px] font-bold uppercase tracking-[0.14em] text-brand-light" data-id="element-257" data-mp="27n9xcdwls5za">
            {latestCategoryLabel(project.category)}
          </span>
        </div>
        <h2 id="latest-detail-title" className="mt-3 font-display text-[32px] font-extrabold uppercase leading-[0.95] text-white sm:text-[38px]" data-id="element-258" data-mp="2hctijq7sgbxb">
          {project.title}
        </h2>
        <p className="mt-2 text-[15px] text-steel-300" data-id="element-259" data-mp="2qf2qc8bo9r70">{project.location}</p>

        {project.relationshipNote && <p className="mt-6 border-l-[3px] border-brand-red pl-4 text-[15px] leading-relaxed text-steel-100" data-id="element-260" data-mp="111phq6wj1h03">
            {project.relationshipNote}
          </p>}

        <h3 className="mt-8 font-display text-[18px] font-bold uppercase tracking-[0.08em] text-white" data-id="element-261" data-mp="2w42y8p8e5ahq">Scope of work</h3>
        <p className="mt-3 text-[16px] leading-relaxed text-steel-100" data-id="element-262" data-mp="3124i3cdn5du9">{project.scope}</p>

        <h3 className="mt-8 font-display text-[18px] font-bold uppercase tracking-[0.08em] text-white" data-id="element-263" data-mp="351wllao6gtsr">Project details</h3>
        <dl className="mt-3 divide-y divide-white/10 border-y border-white/10" data-id="element-264" data-mp="3a06f7gu97mc9">
          {details.map(([label, value]) => <div key={label} className="grid gap-1 py-3 sm:grid-cols-[190px_1fr] sm:gap-6" data-id="element-265" data-mp="3k070h8boocj3">
              <dt className="text-[12px] font-semibold uppercase tracking-[0.1em] text-steel-400 sm:leading-[1.75]" data-id="element-266" data-mp="3orp4y6cx0v8t">
                {label}
              </dt>
              <dd className="text-[15px] text-white" data-id="element-267" data-mp="3ss8x0vimt8o3">{value}</dd>
            </div>)}
        </dl>

        {project.gallery.length > 0 && <>
            <h3 className="mt-8 font-display text-[18px] font-bold uppercase tracking-[0.08em] text-white" data-id="element-268" data-mp="6mvljx0yo48a">Gallery</h3>
            <ul className="mt-3 grid gap-3 sm:grid-cols-2" data-id="element-269" data-mp="grc08n2pffai">
              {project.gallery.map(image => <li key={image.src} data-id="element-270" data-mp="bpcw3az54eci">
                  <img src={image.src} alt={image.alt} loading="lazy" decoding="async" className="aspect-video w-full object-cover" data-id="element-271" data-mp="6rbb2ki5m4ye" />
                  {image.caption && <p className="mt-2 text-[13px] leading-snug text-steel-300" data-id="element-272" data-mp="zicuixsvqmnq">{image.caption}</p>}
                </li>)}
            </ul>
          </>}

        {project.verificationNotes.length > 0 && <ReviewNote className="mt-8" data-id="element-273" data-mp="lp3q7bjsgrc2">
            <ul className="list-disc space-y-1 pl-4" data-id="element-274" data-mp="lo2dl2n4jws8">
              {project.verificationNotes.map(note => <li key={note} data-id="element-275" data-mp="1i8b6hozsszwn">{note}</li>)}
            </ul>
          </ReviewNote>}
      </div>
    </article>;
}